import React from 'react';

import { Box, Typography } from '@mui/material';

import Button from '../../../components/Button/Button';
import { ContentTypeFilter } from './ContentHeader';

type Props = {
  type?: 'post' | 'extra-content' | 'purchased';
  contentType?: ContentTypeFilter;
  isBrand?: boolean;
  productHandle?: () => void;
  inviteHandle?: () => void;
  buyExtraContentHandle?: () => void;
};

export const EmptyState: React.FC<Props> = ({
  type = 'post',
  contentType = 'all',
  isBrand = true,
  productHandle,
  inviteHandle,
  buyExtraContentHandle,
}) => {
  const isTikTokPost = type === 'post' && contentType === 'tiktok';
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
      maxWidth={424}
      gap={'32px'}
    >
      <Box
        component={'img'}
        alt='content-img'
        src={
          type === 'post'
            ? '/png/content-placeholder.png'
            : type === 'extra-content'
              ? '/png/content-placeholder-v2.png'
              : type === 'purchased'
                ? '/png/content-placeholder-v2.png'
                : '/png/content-placeholder.png'
        }
        sx={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
      />
      <Box>
        <Typography textAlign={'center'} fontSize={'18px'} fontWeight={500} mb={1}>
          {isTikTokPost
            ? 'No TikTok posts yet'
            : type === 'post'
              ? 'No posts yet...'
              : type === 'extra-content'
                ? 'No extra content yet...'
                : type === 'purchased'
                  ? 'You have no purchased content'
                  : 'No posts yet...'}
        </Typography>
        <Typography textAlign={'center'} color='#848484' fontSize={'15px'}>
          {isTikTokPost ? (
            'You currently have no active TikTok offers. Create a TikTok offer or duplicate an existing offer to start receiving TikTok videos from models and creators.'
          ) : isBrand ? (
            <>
              {type === 'post'
                ? 'List a product or invite with Collab to receive a reservation. You will see their post here.'
                : type === 'extra-content'
                  ? 'List a product or invite with Collab to receive a reservation. You will see their extra content here.'
                  : type === 'purchased'
                    ? 'The extra content you purchase will be displayed here.'
                    : ''}
            </>
          ) : (
            <>
              {type === 'post'
                ? 'Create an offer or invite with Collab to receive a reservation. You will see their post here.'
                : type === 'extra-content'
                  ? 'Create an offer or invite with Collab to receive a reservation. You will see their extra content here.'
                  : type === 'purchased'
                    ? 'The extra content you purchase will be displayed here.'
                    : ''}
            </>
          )}
        </Typography>
      </Box>
      <Box display={'flex'} alignItems={'center'} gap={'16px'}>
        {type === 'purchased' ? (
          <Button
            variant='outlined'
            color='primary'
            onClick={buyExtraContentHandle}
            fontSize='18px'
          >
            Buy extra content
          </Button>
        ) : (
          <>
            <Button variant='contained' color='primary' onClick={productHandle}>
              {isBrand ? 'List a product' : 'Create an offer'}
            </Button>
            <Button variant='outlined' color='primary' onClick={inviteHandle}>
              Invite with Collabs
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};
